var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeCrossBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#C85D38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3665 7.42097C16.7571 7.03045 16.7571 6.39728 16.3665 6.00676C15.976 5.61624 15.3429 5.61624 14.9523 6.00676L11.1873 9.77183L7.42218 6.00676C7.03166 5.61624 6.39849 5.61624 6.00797 6.00676C5.61745 6.39728 5.61745 7.03045 6.00797 7.42097L9.77304 11.186L6.00749 14.9516C5.61697 15.3421 5.61697 15.9753 6.00749 16.3658C6.39802 16.7563 7.03118 16.7563 7.42171 16.3658L11.1873 12.6003L14.9528 16.3658C15.3433 16.7563 15.9765 16.7563 16.367 16.3658C16.7575 15.9753 16.7575 15.3421 16.367 14.9516L12.6015 11.186L16.3665 7.42097Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCrossBtn);
export default __webpack_public_path__ + "static/media/orange-cross-btn.4554e4bb508b70f5878084366191447d.svg";
export { ForwardRef as ReactComponent };